import { hexToRgb } from "./hexToRgb";
import type { MapColors } from "./MapColors";

// Миникарта в игровых цветах, как в макете: непрозрачное — улицы, полупрозрачное
// светлое — здания, остальное — вне карты (прозрачно).
export const recolorMinimap = (image: HTMLImageElement, colors: MapColors): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (context === null) {
    return canvas;
  }
  context.drawImage(image, 0, 0);
  const data = context.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = data.data;
  const street = hexToRgb(colors.street);
  const building = hexToRgb(colors.building);
  for (let i = 0; i < pixels.length; i += 4) {
    const alpha = pixels[i + 3] ?? 0;
    const fill = alpha >= 100 ? street : (pixels[i] ?? 0) >= 40 ? building : null;
    if (fill === null) {
      pixels[i + 3] = 0;
      continue;
    }
    [pixels[i], pixels[i + 1], pixels[i + 2]] = fill;
    pixels[i + 3] = 255;
  }
  context.putImageData(data, 0, 0);
  return canvas;
};
